import { Slide } from '../components/SlideComponents/slide.types';

// Returns a new slides array where the slide with the given id has its
// durationSeconds increased by `secondsToAdd`. Treats a missing duration
// as 0, matching the pattern used by the on-screen edit-duration control
// in SimpleLiveGameWidgetV2.
export function extendSlideDurationSeconds(
  slides: ReadonlyArray<Slide>,
  slideId: string,
  secondsToAdd: number,
): Slide[] {
  return slides.map(s =>
    s.id === slideId
      ? { ...s, durationSeconds: (s.durationSeconds ?? 0) + secondsToAdd }
      : s,
  );
}
